module.exports = __webpack_public_path__ + "img/produit_2.f3a7d0c3.png";